import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const PiscesShape = ({
  width = 40,
  height = 40,
  fillColor = '#FFF',
  style
}: BaseSVGType) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <g id="Layer_2" data-name="Layer 2">
      <g id="Horoscope" fill={fillColor}>
        <path d="M43,22H33.7A23,23,0,0,1,40.4,7.4a1.9,1.9,0,0,0,0-2.8,1.9,1.9,0,0,0-2.8,0,27.3,27.3,0,0,0-8,17.4H18.4a27.3,27.3,0,0,0-8-17.4,1.9,1.9,0,0,0-2.8,0,1.9,1.9,0,0,0,0,2.8A23,23,0,0,1,14.3,22H5a2,2,0,0,0,0,4h9.3A23,23,0,0,1,7.6,40.6a1.9,1.9,0,0,0,0,2.8,1.9,1.9,0,0,0,2.8,0,27.3,27.3,0,0,0,8-17.4H29.6a27.3,27.3,0,0,0,8,17.4,1.9,1.9,0,0,0,2.8,0,1.9,1.9,0,0,0,0-2.8A23,23,0,0,1,33.7,26H43a2,2,0,0,0,0-4Z" />
      </g>
    </g>
  </svg>
);

export default PiscesShape;
